<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('locationStorage.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('locationStorage.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              v-tooltip="$t('locationStorage.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="ts-text-xs">{{
                    $t('locationStorage.location')
                  }}</label>
                  <a-select
                    v-model="location_id"
                    style="width: 100%; height: 35px"
                    :show-search="true"
                    option-filter-prop="children"
                    mode="multiple"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :class="{ 'is-invalid': errors.has('location_id') }"
                  >
                    <a-select-option
                      v-for="(location, index) in locations"
                      :key="index"
                      :value="location.location_id"
                    >
                      {{ location.location_name_en }}
                    </a-select-option></a-select
                  >
                  <div
                    class="invalid-feedback ts-text-xs"
                    v-if="errors.has('location_id')"
                  >
                    {{ errors.first('location_id') }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <ts-checkbox v-model="isAssignLocation" @change="fetchData()"
                    >is Not Assign Warehouse</ts-checkbox
                  >
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.location ? record.location.location_name_en : '' }}</td>
          <td class="ts-font-khmer">{{ record.storage_name_kh }}</td>
          <td>{{ record.storage_name_en }}</td>
          <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('locationStorage.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <form-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import FormAction from './form'
import { Errors } from 'form-backend-validation'

export default {
  name: 'groupIndex',
  components: {
    FormAction,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      showForm: false,
      locations: [],
    }
  },
  computed: {
    ...mapState('product/locationStorage', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.locationStorage.search
      },
      set(newValue) {
        this.$store.commit('product/locationStorage/SET_SEARCH', newValue)
        this.$store.commit('product/locationStorage/RESET_CURRENT_PAGE')
      },
    },
    location_id: {
      get() {
        return this.$store.state.product.locationStorage.location_id
      },
      set(newValue) {
        this.$store.commit(
          'product/locationStorage/SET_IS_LOCATION_ID',
          newValue
        )
      },
    },
    isAssignLocation: {
      get() {
        return this.$store.state.product.locationStorage.is_not_assign_location
      },
      set(newValue) {
        this.$store.commit(
          'product/locationStorage/SET_IS_ASSIGN_LOCATION',
          newValue
        )
      },
    },
    columns() {
      return [
        {
          name: this.$t('locationStorage.location'),
          style: 'white-space: nowrap;width :300px;',
        },
        { name: this.$t('locationStorage.nameKh') },
        { name: this.$t('locationStorage.nameEn') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' },
      ]
    },
  },
  methods: {
    ...mapActions('product/locationStorage', ['getLocation']),
    getLocations() {
      this.loading = true
      this.getLocation()
        .then((response) => {
          this.locations = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/locationStorage/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    branchFilter(value) {
      this.$store.commit('product/locationStorage/SET_BRANCH_ID', value)
      this.fetchData()
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('product/locationStorage/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('product/locationStorage/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch(
          'product/locationStorage/destroy',
          record.warehouse_storage_id
        )
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    location_id: debounce(function () {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/locationStorage/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getLocations()
      vm.fetchData()
    })
  },
}
</script>
